import { updateValueService } from "../shared/updateValueService";
import { ADD_PRODUCT_MICRO_ELEMENTS, checkItemLocaleCode } from "../components/helper";
import { LOCALE_RU, PROPERTY_TYPE_SELECT, PROPERTY_TYPE_STRING } from "../constant";
import { PROPERTIES_URL, deleteFetchRequest, getFetchRequest, postFetchRequest } from "../store/requests";
import { propertiesStorage } from "./propertiesStorage";
import {errorCallback, makeUrl, successCallbackEmpty} from "../util";
import i18n from "../i18nService";

export const FAT_SOLUBLE_VITAMIN_TYPE = 'fatSoluble';
export const WATER_SOLUBLE_VITAMIN_TYPE = 'waterSoluble';

const checkNeedToAddIsVitamin = (property) => property.isVitamin !== undefined && property.categoryName === ADD_PRODUCT_MICRO_ELEMENTS;

const preparePropertyItem = (property) => {
    const result = {
        categoryName: property.categoryName,
        description: property.description,
        propertyName: property.propertyName,
        propertyType: property.propertyType,
        numberUnits: property.numberUnits,
    };
    if(checkNeedToAddIsVitamin(property)) {
        result.isVitamin = property.isVitamin;
        result.isWaterSoluble = property.isWaterSoluble;
    }
    if(property.userDisplayGroup) {
        result.userDisplayGroup = property.userDisplayGroup;
    }
    if((property.propertyType === PROPERTY_TYPE_SELECT || property.propertyType === PROPERTY_TYPE_STRING) && property.selectValues) {
        result.selectValues = JSON.stringify(property.selectValues);
    } else {
        result.selectValues = null;
    }
    return result;
};

export const findCodeValue = (value, key, array) => {
    let result = '';
    array.forEach(it => it[key] === value ? result = it.id : null);
    return result;
};

export const createUserPropertyType = (i18nInstance = i18n) => {
    return [
        {
            name: i18nInstance.t('app.page.product.property.vitaminMineral'),
            id: 'vitamin_mineral',
        },
        {
            name: i18nInstance.t('app.page.product.property.calories'),
            id: 'calorie_content',
        },
        {
            name: i18nInstance.t('app.page.product.property.pfcPriority'),
            id: 'proteins_fats_carbohydrates',
        },
        {
            name: i18nInstance.t('app.page.product.property.colorDiet'),
            id: 'color',
        },
    ];
};

export const propertySaveService = {
    currentProperty: {},
    lastPropertyUpdateTime: null,
    propertyUpdateObserver: [],
    loadProperty(propertyId, callback) {
        try {
            getFetchRequest(makeUrl([PROPERTIES_URL, propertyId, '/']), (response) => {
                this.currentProperty = {
                    ...response,
                    names: response.names || [],
                    valueNames: response.valueNames || [],
                    synonyms: response.synonyms || [],
                    locale: LOCALE_RU,
                    selectValues: response.selectValues ? JSON.parse(response.selectValues) : null,
                };
                callback(response);
                this.notifyPropertyUpdateObservers();
            }, errorCallback);
        } catch(err) {
            console.log(err);
        }
    },
    getProperty() {
        return this.currentProperty;
    },
    getDateLastUpdate() {
        return this.lastPropertyUpdateTime;
    },
    registerItemUpdateObserver(observer) {
        this.propertyUpdateObserver.push(observer);
    },
    unRegisterItemUpdateObserver(observer) {
        this.propertyUpdateObserver = this.propertyUpdateObserver.filter(propertyUpdateFunction => propertyUpdateFunction !== observer);
    },
    notifyPropertyUpdateObservers() {
        this.propertyUpdateObserver.forEach(propertyUpdateFunction => propertyUpdateFunction(this.currentProperty));
    },
    updatePropertyName(locale, value) {
        try {
            postFetchRequest(makeUrl([PROPERTIES_URL, this.currentProperty.id, '/name/']),
                {
                    localizedName: value,
                    locale: locale,
                },
                () => {
                    if (!this.currentProperty.names) {
                        this.currentProperty.names = [];
                    }
                    const existing = this.currentProperty.names.find((it) => it.locale === locale);
                    if (existing) {
                        existing.name = value;
                    } else {
                        this.currentProperty.names.push({
                            locale: locale,
                            name: value,
                        });
                    }
                    const storedProperty = propertiesStorage.getById(this.currentProperty.id);
                    if (storedProperty) {
                        storedProperty.names = [...this.currentProperty.names];
                    }
                    this.lastPropertyUpdateTime = Date.now();
                    this.notifyPropertyUpdateObservers();
                }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },
    updateItemLocalization(locale, value) {
        this.updatePropertyName(locale, value);
    },
    updateValueLocalization(locale, value, code) {
        try {
            if (!this.currentProperty.id || !checkItemLocaleCode(code)) {
                return;
            }
            postFetchRequest(makeUrl([PROPERTIES_URL, this.currentProperty.id, '/value/', code, '/name/']),
                {
                    localizedName: value,
                    locale: locale,
                },
                () => {
                    if (!this.currentProperty.valueNames) {
                        this.currentProperty.valueNames = [];
                    }
                    const existing = this.currentProperty.valueNames.find(
                        (it) => it.valueCode === code && it.locale === locale,
                    );
                    if (existing) {
                        existing.name = value;
                    } else {
                        this.currentProperty.valueNames.push({
                            valueCode: code,
                            locale: locale,
                            name: value,
                        });
                    }
                    const storedProperty = propertiesStorage.getById(this.currentProperty.id);
                    if (storedProperty) {
                        storedProperty.valueNames = [...this.currentProperty.valueNames];
                    }
                    this.lastPropertyUpdateTime = Date.now();
                    this.notifyPropertyUpdateObservers();
                }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },

    updatePropertyValue(filedName, value) {
        try {
            this.currentProperty[filedName] = value;
            this.notifyPropertyUpdateObservers();
            updateValueService.updateItemValue(() => {
                this.lastPropertyUpdateTime = Date.now();
                this.updateProperty();
            });
        } catch(err) {
            console.log(err);
        }
    },
    updateProperty() {
        try {
            postFetchRequest(makeUrl([PROPERTIES_URL, this.currentProperty.id, '/']), preparePropertyItem(this.currentProperty), successCallbackEmpty, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },
    changeVitaminType(value) {
        try {
            this.currentProperty.isWaterSoluble = value;
            this.lastPropertyUpdateTime = Date.now();
            this.notifyPropertyUpdateObservers();
            this.updateProperty();
        } catch(err) {
            console.log(err);
        }
    },
    updatePropertyValueField(value) {
        try {
            if(this.currentProperty.selectValues) {
                this.currentProperty.selectValues.push(value);
            } else {
                this.currentProperty.selectValues = [value];
            }
            this.updateProperty();
            this.notifyPropertyUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    },
    deleteSelectValue(value) {
        this.currentProperty.selectValues = this.currentProperty.selectValues.filter(it => it !== value);
        this.notifyPropertyUpdateObservers();
        this.updateProperty();
    },
    addSynonym(locale, synonym) {
        const text = (synonym || '').trim();
        if (!this.currentProperty.id || !text) {
            return;
        }
        postFetchRequest(
            makeUrl([PROPERTIES_URL, this.currentProperty.id, '/synonym/']),
            { locale, synonym: text },
            () => {
                this.loadProperty(this.currentProperty.id, () => null);
            },
            errorCallback,
            true,
        );
    },
    deleteSynonym(synonymId) {
        if (!this.currentProperty.id || !synonymId) {
            return;
        }
        deleteFetchRequest(
            makeUrl([PROPERTIES_URL, this.currentProperty.id, '/synonym/', synonymId, '/']),
            () => {
                this.currentProperty.synonyms = (this.currentProperty.synonyms || [])
                    .filter((it) => it.id !== synonymId);
                this.notifyPropertyUpdateObservers();
            },
            errorCallback,
        );
    },
};
